<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div (cdkDragEnded)="dragEnded($event)" cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-window-content restorable-window">
    <div cdkDragHandle class="modal-header">
        <h4>Tunnels</h4>
        <button (click)="clear()" matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>

    <div class="modal-body">
        <div class="tunnels-list-actions">
            <div class="tunnels-filter-container">
                <input
                        (ngModelChange)="filterChanged($event)"
                        [ngModel]="searchString"
                        class="form-control form-control-sm font-size-12 filter-input"
                        id="filterInput"
                        placeholder="Filter tunnels..."
                />
            </div>
            <button (click)="tunnelsService.toggleAllTunnelsView()" windeGreen>
                {{ tunnelsService.areAllTunnelsDisplayed ? 'Hide all Tunnels' : 'Highlight all Tunnels' }}
            </button>
        </div>

        <div *ngIf="locationsToShow$ | async as report">
            <div *ngIf="report.buLocationsWithoutTunnels.length" class="tunnel-expand-margin">
                <h6 (click)="toggleOpenedLists(tunnelListType.WITHOUT_TUNNELS)"
                    (keydown)="toggleOpenedLists(tunnelListType.WITHOUT_TUNNELS)" class="devices-list-title">
                    Locations Without Tunnels ({{ report.buLocationsWithoutTunnels.length }})
                    <button windeActionIcon>
                        <sui-svg-icon [icon]="showBuLocationsWithoutTunnels ? 'angle-up' : 'angle-down'" windeGrey/>
                    </button>
                </h6>
                <table
                        *ngIf="showBuLocationsWithoutTunnels"
                        aria-describedby="buLocationsWithoutTunnels"
                        class="table table-smaller-padding"
                >
                    <th style="display: none"></th>
                    <tbody>
                        <tr *ngFor="let location of report.buLocationsWithoutTunnels">
                            <td>
                                <winde-node-pointer
                                        [listData]="{ nodeNames: location, placement: 'top', cropName: 20 }"
                                ></winde-node-pointer>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div *ngIf="report.buLocationsWithSingleTunnel.length" class="tunnel-expand-margin">
                <h6 (click)="toggleOpenedLists(tunnelListType.WITH_SINGLE_TUNNELS)"
                    (keydown)="toggleOpenedLists(tunnelListType.WITH_SINGLE_TUNNELS)" class="devices-list-title">
                    Locations With Single Tunnel ({{ report.buLocationsWithSingleTunnel.length }})
                    <button windeActionIcon>
                        <sui-svg-icon [icon]="showBuLocationsWithSingleTunnel ? 'angle-up' : 'angle-down'" windeGrey/>
                    </button>
                </h6>
                <table
                        *ngIf="showBuLocationsWithSingleTunnel"
                        aria-describedby="buLocationsWithSingleTunnel"
                        class="table table-smaller-padding"
                >
                    <th style="display: none"></th>
                    <tbody>
                        <tr *ngFor="let location of report.buLocationsWithSingleTunnel">
                            <td>
                                <winde-node-pointer
                                        [listData]="{ nodeNames: location, placement: 'top', cropName: 20 }"
                                ></winde-node-pointer>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div *ngIf="tunnelsToShow$ | async as tunnelsForType; else noTunnelsToDisplayTemplate">
            <ng-container *ngFor="let tunnelsWithType of tunnelsForType">
                <h5>{{ tunnelsWithType.type | translateEnum: 'tunnelTypeEnum' }}</h5>
                <ng-container *ngFor="let tunnel of tunnelsWithType.tunnels; let i = index">
                    <section [ngClass]="{ 'tunnel-add-element-background': i % 2 === 0 }" class="tunnel-block">
                        <div class="tunnel-header">
                            <div>{{ 'Tunnel: ' + tunnel.id }}</div>
                            <div>
                                <winde-node-pointer
                                        [listData]="{ nodeNames: tunnel.tunnelNodeNames[0], placement: 'top', cropName: 10 }"
                                ></winde-node-pointer>
                                -
                                <winde-node-pointer
                                        [listData]="{
                                        nodeNames: tunnel.tunnelNodeNames[tunnel.tunnelNodeNames.length - 1],
                                        placement: 'top',
                                        cropName: 10
                                    }"
                                ></winde-node-pointer>
                            </div>
                            <div class="action-btn-container">
                                <button
                                        (click)="tunnelsService.toggleTunnelView(tunnel)"
                                        class="btn btn-link btn-sm map-button font-size-12 mr-2"
                                >
                                    {{ tunnel.isShown() ? 'Hide on map' : 'Highlight on map' }}
                                </button>
                                <button (click)="tunnel.isExpanded = !tunnel.isExpanded" windeActionIcon>
                                    <sui-svg-icon [icon]="tunnel.isExpanded ? 'caret-up' : 'caret-down'" windeGrey/>
                                </button>
                            </div>
                        </div>
                        <div *ngIf="tunnel.isExpanded" class="tunnel-details custom-scroll-bar">
                            <ul class="steplist">
                                <ng-container *ngFor="let node of tunnel.tunnelNodeNames">
                                    <li>
                                        <winde-node-pointer
                                                [listData]="{ nodeNames: node, placement: 'top', cropName: 10 }">
                                        </winde-node-pointer>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                    </section>
                </ng-container>
            </ng-container>
        </div>
        <ng-template #noTunnelsToDisplayTemplate>
            <div class="no-tunnels-text">No tunnels to display</div>
        </ng-template>
    </div>
</div>
